import React from 'react';
import { useTranslation } from 'next-i18next';
import styled from '@emotion/styled';
import { Button } from 'components/commons/Button';

const Root = styled.div`
  margin: 2rem;
`;
const Title = styled.h2``;
const Message = styled.div`
  margin: 1rem;
`;

interface Props {
  onShowForm: () => void;
}

export const SucessSendMessage = ({ onShowForm }: Props) => {
  const { t } = useTranslation('contact');
  return (
    <Root>
      <Title>{t('form.successMessage.title')}</Title>
      <Message>
        {(t('form.successMessage.message', { returnObjects: true }) as []).map(
          (message: string, key) => (
            <Message key={key}>{message}</Message>
          )
        )}
      </Message>
      <Button type="button" onClick={onShowForm}>
        {t('form.successMessage.backMessage')}
      </Button>
    </Root>
  );
};
